module.exports = __webpack_public_path__ + "img/plate02_02.797b9e9d.png";